<template>
  <div>

    <div v-if="!getMember.arbitrage || !getMember.arbitrage.length>0">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-body">
              <p>
                Ce membre n'a aucune prestation d'arbitrage
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form role="form" v-if="getMember.arbitrage && getMember.arbitrage.length>0">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">A arbitré {{ getMember.arbitrage.length }} compétitions</h3>
            </div>
            <div class="box-body">
              <table id="tableComite"
                     class="table table-hover table-striped table-bordered">
                <thead>
                <tr>
                  <th>Date</th>
                  <th>Compétition</th>
                  <th>Arbitrage</th>
                  <!--<th>Afficher dans son MyABFT</th>-->
                </tr>
                </thead>
                <tbody>
                <tr v-for="competition in getMember.arbitrage">
                  <td>
                    {{ competition.competition.date_debut }}
                  </td>
                  <td>
                    <router-link
                      v-if="competition"
                      :to="{ name: 'Competition', params: { competition_id: competition.id_compet }}">
                      {{ competition.competition.competition }}
                    </router-link>
                  </td>
                  <td>
                    OUI
                  </td>

                  <!--<td>-->
                  <!--<i class="fa fa-refresh fa-spin" v-if="loading[equipe[0].id_club]==true"></i>-->
                  <!--<select name="" v-if="!loading[equipe[0].id_club] || loading[equipe[0].id_club]==false"-->
                  <!--@change="setClubInExtranet(equipe[0].id_club,equipe[0].show_in_extranet)" v-model="equipe[0].show_in_extranet" id="">-->
                  <!--<option value="0">NON</option>-->
                  <!--<option value="1">OUI</option>-->
                  <!--</select>-->
                  <!--</td>-->
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import Datepicker from 'vuejs-datepicker';

var $ = require('jquery');
var variables = require('../../../assets/js/variables')
var _ = require('underscore')
var moment = require('moment')

export default {
  data() {
    return {
      loading: {},
      dataTableRankingMember: null,
    }
  },
  computed: {
    ...mapGetters({
      getMember: 'getMember',
      getRoute: 'getRoute',
    }),

  },
  mounted: function () {
    var these = this
    // this.$nextTick(function () {
    //     setTimeout(function () {
    //         these.refreshListings()
    //     }, 1000)
    // })
  },
  created() {
  },
  watch: {},
  components: {},
  methods: {
    ...mapActions({}),
    refreshListings: function () {
      // this.dataTableRankingMember = $("#rankingMember").DataTable({
      //     language: variables.dt_french(),
      //     "paging": true,
      //     "ordering": true,
      //     "info": true,
      //     "autoWidth": true,
      // });
    },

    filters: {
      idFormat: function (value) {
        return new Intl.NumberFormat("de-DE").format(value)
      }
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/Membre/ListingArbitrage.vue